import { call, put } from 'redux-saga/effects';
import Http from '../../../../libs/Http';

export function* fetchBalance(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const response = yield call(Http.get, '/admin/balance', {
    query: {}
  });
  yield put({
    $global: true,
    type: 'SET_BALANCE',
    payload: response.data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeFirst('FETCH_BALANCE', fetchBalance),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Balance/Balance.sagas.js